import { CardView } from "../../components/CardView.js";
import { getCardRewardPools } from "./catalogFilter.js";
import type { CardDefinition } from "../../domain/types/index.js";

const TIER = {
  starter: "初期",
  small: "小規模",
  medium: "中規模",
  large: "大規模",
  none: "報酬対象外",
} as const;

export function CatalogCard({ card }: { card: CardDefinition }) {
  const pools = getCardRewardPools(card.id);
  return (
    <figure className="catalog-item">
      <CardView
        card={{ instanceId: `catalog-${card.id}`, cardId: card.id }}
        definition={card}
        disabled
      />
      <figcaption>
        {TIER[card.rewardTier]} · {pools.length > 0 ? `報酬：${pools.join("・")}` : "プール外"}
      </figcaption>
    </figure>
  );
}
